import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { TextField, TextFieldWidth } from "azure-devops-ui/TextField";

const simpleObservable = new ObservableValue<string>("");

export default class TextFieldExample extends React.Component<any, any> {
    public render(): JSX.Element {
        return (
            <TextField
                value={simpleObservable}
                onChange={(e, newValue) => (simpleObservable.value = newValue)}
                placeholder="Search keyword"
                width={TextFieldWidth.standard}
            />
        );
    }
}
